module.exports = __webpack_public_path__ + "img/hest18.98c56280.jpg";